import React, { ReactElement } from 'react';
import { FilterTag, FilterTagGroup } from 'slovlex-idsk-react-components';
import classNames from 'classnames';
import LegMaterialListFilter from '../../../../model/legislativnyMaterial/LegMaterialListFilter';
import { SafeParameterSetter } from '../../../../types/SafeParameterSetter';
import mapDate from '../../../../function/mapDate';
import { getStadiumNazov } from '../../../../model/legislativnyMaterial/StadiumMaterialu';

interface Props {
  filter: LegMaterialListFilter;
  onUpdateField: SafeParameterSetter<LegMaterialListFilter>;
  className?: string;
  isPredbezna?: boolean;
  /**
   * Pre desktop. V mobilnom modale ma tlacidlo na starosti MobileFilterModal,
   * takze tam sa nechava nevyplnene.
   */
  onClearFilters?: () => void;
}

const putDatumyOdDoToArray = (
  datumOd: Date,
  datumDo: Date,
): string[] => {
  if (datumOd && datumDo) {
    return [`od ${mapDate(datumOd)}`,
      `do ${mapDate(datumDo)}`];
  }
  if (datumOd) {
    return [`od ${mapDate(datumOd)}`];
  }
  if (datumDo) {
    return [`do ${mapDate(datumDo)}`];
  }
  return [];
};

const FilterTagsComponent = ({
  filter,
  onUpdateField,
  className = '',
  isPredbezna = false,
  onClearFilters = null,
}: Props): ReactElement => {
  const classes: string = classNames('elegislativa-filter-tag-component', className);

  return (
    <FilterTagGroup className={classes} onClearFilters={onClearFilters}>
      <FilterTag
        title="Štádium materiálu"
        data={getStadiumNazov(filter.stadium)}
        onClear={() => onUpdateField('stadium', null)}
      />
      <FilterTag
        title="Hľadaný výraz"
        data={filter.searchTextVyraz}
        onClear={() => {
          onUpdateField('searchTextVyraz', '');
        }}
      />
      <FilterTag
        title="Číslo procesu"
        data={filter.searchTextCislo}
        onClear={() => {
          onUpdateField('searchTextCislo', '');
        }}
      />
      <FilterTag
        title="Názov materiálu"
        data={filter.searchTextNazov}
        onClear={() => {
          onUpdateField('searchTextNazov', '');
        }}
      />
      {!isPredbezna && (
        <FilterTag
          title="Typ materiálu"
          data={filter.typ?.nazov}
          onClear={() => onUpdateField('typ', null)}
        />
      )}
      <FilterTag
        title="Právna oblasť"
        data={filter.oblastList.map(oblast => oblast.nazov)}
        onClear={(title) => onUpdateField(
          'oblastList',
          filter.oblastList.filter(oblast => oblast.nazov !== title),
        )}
      />
      <FilterTag
        title="Rezortné číslo"
        data={filter.searchTextRezort}
        onClear={() => {
          onUpdateField('searchTextRezort', '');
        }}
      />
      <FilterTag
        title="Ročník"
        data={filter.searchTextRocnik}
        onClear={() => {
          onUpdateField('searchTextRocnik', '');
        }}
      />
      <FilterTag
        title="Zodpovedný predkladateľ"
        data={filter.predkladatel?.nazov}
        onClear={() => {
          onUpdateField('predkladatel', null);
        }}
      />
      <FilterTag
        title="Zodpovedná inštitúcia"
        data={filter.institucia?.nazov}
        onClear={() => {
          onUpdateField('institucia', null);
        }}
      />
      <FilterTag
        title="Dátum zmeny"
        data={putDatumyOdDoToArray(filter.datumZmenyOd, filter.datumZmenyDo)}
        onClear={(title) => {
          if (title.startsWith('od')) {
            onUpdateField('datumZmenyOd', null);
          }
          if (title.startsWith('do')) {
            onUpdateField('datumZmenyDo', null);
          }
        }}
      />
    </FilterTagGroup>
  );
};

export default FilterTagsComponent;
